export const MARVEL_REQUEST = "MARVEL_REQUEST";
export const MARVEL_SUCCESS = "MARVEL_SUCCESS";
export const MARVEL_FAILED = "MARVEL_FAILED";
